"use strict";
exports.__esModule = true;
exports.ServiceSettingList = exports.ServiceIntervalList = exports.ServiceLengthList = exports.ServiceTypeList = exports.ServiceNameList = void 0;
exports.ServiceNameList = [
    'Assistive Technology Devices and Services',
    'Audiology Services',
    'Early Identification, Screening and Assessment Services',
    'Family Training, Counseling, and Home Visits',
    'Health Services',
    'Hearing Services',
    'Medical Services',
    'Nursing Services',
    'Nutrition Services',
    'Occupational Therapy',
    'Physical Therapy',
    'Psychological Services',
    'Service Coordination',
    'Social Work Services',
    'Special Instruction',
    'Speech/Language Pathology',
    'Transportation and Related Costs',
    'Vision Services',
];
exports.ServiceTypeList = ['Individual', 'Group'];
exports.ServiceLengthList = [
    '15 min',
    '30 min',
    '45 min',
    '60 min',
    '75 min',
    '90 min',
    '105 min',
    '120 min',
];
exports.ServiceIntervalList = ['Day', 'Week', 'Month', 'Quarter'];
exports.ServiceSettingList = ['Home', 'Community-based', 'Other'];
//# sourceMappingURL=ESITService.js.map